import React from 'react'
import { Link } from 'react-router-dom'
import LinksMap from '../components/LinksMap'
import { useNavigate } from 'react-router-dom'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/cart.css'

export default function Cart() {
  const navigate = useNavigate()

  function handleCheckout(){
    navigate('/checkout')
  }

  return (
    <div className='cart_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'Cart', path: '/cart', active: true}]} pageName='Cart' />

      <div className='container wrapper'>
        <div className='main_content'>
          <div className='cartlist'>
            <div className='cart_indicator card'>
              <div className='thumbnail'></div>
              <div className='details'>
                <div className='title'>Name</div>
                <div className='price'>Price</div>
                <div className='quantity'>
                  Quantity
                </div>
                <div className='subtotal'>Subtotal</div>
              </div>
            </div>
            <div className='card'>
              <div className='thumbnail'>
                <img src='https://via.placeholder.com/150' alt='product' />
                <button className='remove_btn fas fa-times'></button>
              </div>
              <div className='details'>
                <div className='title'>Black Grey Headset</div>
                <div className='price'>$200</div>
                <div className='quantity'>
                  <button className='fas fa-plus'></button>
                  <input type='number' />
                  <button className='fas fa-minus'></button>
                </div>
                <div className='subtotal'>$300</div>
              </div>
            </div>
            
            <div className='card'>
              <div className='thumbnail'>
                <img src='https://via.placeholder.com/150' alt='product' />
                <button className='remove_btn fas fa-times'></button>
              </div>
              <div className='details'>
                <div className='title'>Black Grey Headset</div>
                <div className='price'>$200</div>
                <div className='quantity'>
                  <button className='fas fa-plus'></button>
                  <input type='number' />
                  <button className='fas fa-minus'></button>
                </div>
                <div className='subtotal'>$300</div>
              </div>
            </div>
          </div>
        </div>

        <div className='right_content'>
          <div className='cart_summary'>
            <div className='items summery'>
              <div className='title'>Items</div>
              <div className='value'>02</div>
            </div>
            <div className='total_price summery'>
              <div className='title'>Total Price</div>
              <div className='value'>$200</div>
            </div>
          </div>
          
          <div className='actions'>
            <button onClick={handleCheckout}>CHECKOUT</button>
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='cart_empty'>
          <span className='far fa-shopping-cart'></span>
          <p>No products added to the cart</p>
          <Link to='/products'>GO SHOP</Link>
        </div>
      </div>
    </div>
  )
}
